/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RecommendationDTO,
    RecommendationDTOFromJSON,
    RecommendationDTOFromJSONTyped,
    RecommendationDTOToJSON,
} from './RecommendationDTO';
import {
    ReportType,
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
} from './ReportType';

/**
 * 
 * @export
 * @interface BaseReportDTO
 */
export interface BaseReportDTO {
    /**
     * 
     * @type {string}
     * @memberof BaseReportDTO
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaseReportDTO
     */
    reportDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaseReportDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseReportDTO
     */
    studyProgramName?: string | null;
    /**
     * 
     * @type {Blob}
     * @memberof BaseReportDTO
     */
    file?: Blob | null;
    /**
     * 
     * @type {string}
     * @memberof BaseReportDTO
     */
    filePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseReportDTO
     */
    description?: string | null;
    /**
     * 
     * @type {ReportType}
     * @memberof BaseReportDTO
     */
    reportType?: ReportType;
    /**
     * 
     * @type {Date}
     * @memberof BaseReportDTO
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Array<RecommendationDTO>}
     * @memberof BaseReportDTO
     */
    recommendations?: Array<RecommendationDTO> | null;
}

export function BaseReportDTOFromJSON(json: any): BaseReportDTO {
    return BaseReportDTOFromJSONTyped(json, false);
}

export function BaseReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'reportDate': !exists(json, 'reportDate') ? undefined : (new Date(json['reportDate'])),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'studyProgramName': !exists(json, 'studyProgramName') ? undefined : json['studyProgramName'],
        'file': !exists(json, 'file') ? undefined : json['file'],
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'reportType': !exists(json, 'reportType') ? undefined : ReportTypeFromJSON(json['reportType']),
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'recommendations': !exists(json, 'recommendations') ? undefined : (json['recommendations'] === null ? null : (json['recommendations'] as Array<any>).map(RecommendationDTOFromJSON)),
    };
}

export function BaseReportDTOToJSON(value?: BaseReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reportDate': value.reportDate === undefined ? undefined : (value.reportDate.toISOString()),
        'studyProgramId': value.studyProgramId,
        'studyProgramName': value.studyProgramName,
        'file': value.file,
        'filePath': value.filePath,
        'description': value.description,
        'reportType': ReportTypeToJSON(value.reportType),
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'recommendations': value.recommendations === undefined ? undefined : (value.recommendations === null ? null : (value.recommendations as Array<any>).map(RecommendationDTOToJSON)),
    };
}

